import { ExcelBatchOperationEnum, GenderEnum } from '@/constant';
import { Dispatch, SetStateAction } from 'react';

import { DefaultOptionType } from 'antd/es/select';
import { formatDate } from 'utils';

import dayjs from 'dayjs';
import { Event, View } from 'lib/react-big-calendar';

export const mapPropsToValues = () => {};

export enum TypeAssignmentCalendar {
	RECRUITER = 'RECRUITER ',
	APPLICANT = 'APPLICANT',
}

export interface IPropsCalendar {
	calendarRef: React.RefObject<any>;
	showEnableApplicants: (date: Date) => void;
	showDefineAssignment: (date: string) => void;
	showDetailDispatch: (id: number) => void;
	currentDate: Date;
	setCurrentDate: Dispatch<SetStateAction<Date>>;
	setIsUpdateAssignmentSuccess: Dispatch<SetStateAction<boolean>>;
	handleCreateAssignmentSuccess: (startDate?: string) => void;
	handleDeletePublicAssignment: (id: number, startDate?: string) => void;
}

export interface IValues {
	unitId: string;
	publicMainFranchiseId: string;
	searchType: TypeAssignmentCalendar;
	searchValue: string | null;
	startDate: string;
	endDate: string;
}

export interface IPropsSearchForm {
	currentDate: Date;
	onNavigate?: (startDate: string) => void;
	isUpdateAssignmentSuccess: boolean;
	setIsUpdateAssignmentSuccess: Dispatch<SetStateAction<boolean>>;
}

export const InitValues: IValues = {
	unitId: '',
	publicMainFranchiseId: '',
	searchType: TypeAssignmentCalendar.RECRUITER,
	searchValue: '',
	startDate: '',
	endDate: '',
};

export const SEARCH_TYPES_OPTION: DefaultOptionType[] = [
	{
		label: 'assignment-calendar.form-search.recruiter-name',
		value: TypeAssignmentCalendar.RECRUITER,
	},
	{
		label: 'assignment-calendar.form-search.applicant-name',
		value: TypeAssignmentCalendar.APPLICANT,
	},
];

export enum NavigateType {
	PREVIOUS_YEAR = 'PreviousYear',
	PREVIOUS_MONTH = 'PreviousMonth',
	NEXT_YEAR = 'NextYear',
	NEXT_MONTH = 'NextMonth',
	TODAY = 'Today',
}

export interface CEvent extends Event {
	id: number;
	resource: {
		franchiseRequestNum: number;
		assignmentNum: number;
		productionTypeDetail: string;
		startTime: string;
		endTime: string;
		applicantHistories: {
			id: number;
			fullName: string;
			grade: string;
			gender: GenderEnum;
		}[];
		publicFranchiseId: number;
		franchiseId: number;
		name: string;
		memo: string;
		relaxTime: number;
	};
}

export enum TypeFilterAssignmentEnum {
	ALL = 'All',
	UNASSIGNED = 'Unassigned',
}

export const getFirstDateLastDateInView = (
	view: View = 'month',
	currentDate: Date
): { startDate: string; endDate: string } => {
	const dCurrentDate = dayjs(currentDate);

	if (view === 'month') {
		const thisYear = dCurrentDate.year();
		const thisMonth = dCurrentDate.month(); // (January as 0, December as 11)
		const daysInMonth = dCurrentDate.daysInMonth(); //total day in month
		const dayObjOf1 = dayjs(
			`${thisYear}.${(thisMonth + 1).toString().padStart(2, '0')}.01`,
			'YYYY-MM-DD'
		); //day 1 of month
		const dayObjLast = dayjs(
			`${thisYear}.${(thisMonth + 1).toString().padStart(2, '0')}.${daysInMonth}`,
			'YYYY-MM-DD'
		);

		return {
			startDate: formatDate(dayObjOf1),
			endDate: formatDate(dayObjLast),
		};
	} else {
		const dayOfWeek = dCurrentDate.day(); //Returns numbers from 0 (Sunday) to 6 (Saturday)

		return {
			startDate: formatDate(dCurrentDate.subtract(dayOfWeek, 'day').toString()),
			endDate: formatDate(dCurrentDate.add(6 - dayOfWeek, 'day').toString()),
		};
	}
};

export const getExcelOptions = (
	uploadExcelSuccessCallback: () => void,
	onDownload: (reason: string, callback?: () => void) => void
) => [
	{
		key: ExcelBatchOperationEnum.UPLOAD_PUBLIC_ASSIGNMENT_LIST,
		label: '엑셀 일괄 등록',
		callback: uploadExcelSuccessCallback,
	},
	{
		key: ExcelBatchOperationEnum.DOWNLOAD_PUBLIC_ASSIGNMENT_LIST,
		label: '엑셀 일괄 다운로드',
		trigger: onDownload,
	},
];
